import { render } from "./OlusturdugunuzAltliklarSvg.vue?vue&type=template&id=57f78d5a"
import script from "./OlusturdugunuzAltliklarSvg.vue?vue&type=script&lang=js"
export * from "./OlusturdugunuzAltliklarSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__